/** True when the app is served from a local dev host. Used to gate dev-only UI
 * (e.g. the theme color playground) so it never renders in production. */
export function isLocalhost(): boolean {
  if (typeof window === "undefined") return false;
  return /^(localhost|127\.0\.0\.1|\[::1\]|::1|0\.0\.0\.0)$/.test(window.location.hostname);
}
